import { render } from "./DeptView.vue?vue&type=template&id=e9557e46&scoped=true"
import script from "./DeptView.vue?vue&type=script&lang=js"
export * from "./DeptView.vue?vue&type=script&lang=js"

import "./DeptView.vue?vue&type=style&index=0&id=e9557e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9557e46"]])

export default __exports__